import React from 'react'

import FeatureSectionEight from '@src/quince-components/src/atoms/featureSectionEight'
import CUSTOM_SECTION_TYPE from '@src/quince-site-common/src/domains/CustomSectionType'
import useDeviceInfo, { DEVICE_TYPES } from '@src/quince-site-common/src/hooks/useDeviceInfo'
import { checkIsNewLongFormSectionHidden } from '@src/quince-site-pdp/src/helper/product.helper'
import { ProductPageSectionProps } from '@src/quince-site-pdp/src/types/productPage.types'

import ImageWithTextProductDetailsSection from './StackedImageWithTextProductDetailsSection'

function StackedNewLongForm(props: ProductPageSectionProps) {
  const deviceInfo = useDeviceInfo()
  const isDesktop = deviceInfo.deviceType === DEVICE_TYPES.DESKTOP
  const sections = isDesktop ? props.product.desktopSections : props.product.mobileSections
  const stackLongForm = sections.find(section => section.sectionType === CUSTOM_SECTION_TYPE.STACKED_NEW_LONG_FORM)

  const isSectionHidden = checkIsNewLongFormSectionHidden(stackLongForm)
  if (isSectionHidden) {
    return null
  }

  return (
    <div>
      {stackLongForm?.subSections?.map((section, idx) => {
        if (section?.sectionType === CUSTOM_SECTION_TYPE.FEATURE_SECTION_2) {
          return (
            <div key={idx}>
              <ImageWithTextProductDetailsSection prodDetails={section} />
            </div>
          )
        } else {
          return (
            <div key={idx}>
              <FeatureSectionEight section={section} />
            </div>
          )
        }
      })}
    </div>
  )
}

export default StackedNewLongForm
